import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
`

export const ConfirmedAt = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`
